import script from "./OrderLifecycleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderLifecycleBar.vue?vue&type=script&setup=true&lang=js"

import "./OrderLifecycleBar.vue?vue&type=style&index=0&id=10f538e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f538e1"]])

export default __exports__